
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { TAccount } from "@/models/account";
import { API_ROUTES } from "@/utils/API";
import { SMToaster } from "@/store";

@Component({
  components: {
    CodeInput: () =>
      import("@/pages/Layout/views/Employer/views/MyAccount/components/TheCodeInput.vue"),
  },
})
export default class CodePopup extends Vue {
  @Prop({ type: Boolean, default: false }) readonly show!: boolean;
  @Prop({ type: Object, required: true }) readonly account!: TAccount;
  @Prop({ type: Number, required: true }) readonly timeStamp!: number;

  showPopup = false;

  loading = false;

  @Watch("show", { immediate: true })
  showPopupChanged(val: boolean) {
    this.showPopup = val;
  }

  open() {
    this.showPopup = true;
  }

  close() {
    this.showPopup = false;

    this.$emit("close");
  }

  resendCode() {
    this.isTimer = true;

    this.$emit("resend-code");
  }

  code = "";

  setCode(code: string) {
    this.code = code;
  }

  isError = false;

  setError(isError: boolean) {
    this.isError = isError;
  }

  isTimer = true;

  updateTimer(isRunning: boolean) {
    this.isTimer = isRunning;
  }

  async validateCode() {
    if (!this.timeStamp || !this.code) return;

    try {
      this.loading = true;

      const { data } = await this.axios.get<boolean>(
        API_ROUTES.MY_ACCOUNT_PASSWORD_VALIDATE(this.code, this.timeStamp)
      );

      this.isError = !data;

      if (!data) return;

      this.$emit("code-ok");

      this.close();
    } catch (e) {
      SMToaster.emitError(e);

      this.close();
    } finally {
      this.loading = false;
    }
  }
}
